var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9A8 8 0 111 9a8 8 0 0116 0zm1 0A9 9 0 110 9a9 9 0 0118 0zm-9.839 5h1.265V6.604H8.16V14zm.082-9.878a.763.763 0 00-.184.52c0 .205.061.376.184.512.128.137.315.205.56.205.247 0 .434-.068.561-.205a.722.722 0 00.192-.512.747.747 0 00-.192-.52c-.127-.141-.314-.212-.56-.212-.246 0-.433.07-.56.212z"
  })));
};
export default SvgInfo;